<form-table
  [formType]="formTypeEnum.EBF"
  [all]="showAllForms"
  [displayedColumns]="['sequenceNumber', 'systemAffected', 'status']"
  [filter]="formsFilter"
  (rowClick)="rowSelectedEvent($event)"
  (error)="alert.error($event)"
>
</form-table>
